export default __webpack_public_path__ + "static/media/ic_top-3.74959e23.svg";